module.exports = __webpack_public_path__ + "img/cn_pocket-17.eafaf6a.jpg";